import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../services/i18nService';
import { getA11yAttributesV2 } from '../../../../services/a11yIIBScreenReaderService';

import styles from '../../testOverview.scss';

/**
 * Component displayed when microphone diagnosis has failed
 */
const MicDiagnosisFailed = ({ onRetry }) => (
    <div
        className={styles.micHealthCheckFailedCustom}
        {...getA11yAttributesV2({
            role: 'alert',
            tabIndex: 0,
        })}
    >
        <div className={styles.micHealthCheckFailedGrid}>
            <div className={styles.micHealthCheckFailedIconCol}>
                <i className={`fa fa-exclamation-circle ${styles.micHealthCheckFailedIcon}`} aria-hidden="true" />
            </div>
            <div className={styles.micHealthCheckFailedTextCol}>
                <span className={styles.micHealthCheckFailedTitle}>
                    {t('hardwareAccessCheck.micHealthDiagnosisFailed')}
                </span>
            </div>
            <div className={styles.micHealthCheckFailedButtonCol}>
                <button
                    id="retry_mic_health_check_button"
                    className={styles.micHealthCheckFailedRetry}
                    onClick={onRetry}
                    {...getA11yAttributesV2({
                        'aria-label': t('hardwareAccessCheck.retryMicHealthCheck'),
                    })}
                >
                    {t('hardwareAccessCheck.retryMicHealthCheck')}
                </button>
            </div>
            <div className={styles.micHealthCheckFailedMessage}>
                {t('hardwareAccessCheck.micHealthCheckFailedMessage')}
            </div>
        </div>
    </div>
);

MicDiagnosisFailed.propTypes = {
    onRetry: PropTypes.func.isRequired,
};

export default MicDiagnosisFailed;
